import React, { useState } from "react";
import config from "../../config";
import { authFetch } from "../../utils/Security/authFetch";
import ReportingView from "./ReportingView";

const Reporting: React.FC = () => {
  const [periodFrom, setPeriodFrom] = useState("");
  const [periodTo, setPeriodTo] = useState("");
  const [module, setModule] = useState("");
  const [customers, setCustomers] = useState<string[]>([]);

  // PIE DATA
  const [complaints, setComplaints] = useState<any[]>([]);
  const [status, setStatus] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [errorTypes, setErrorTypes] = useState<any[]>([]);

  // BAR DATA
  const [networkData, setNetworkData] = useState<any[]>([]);

  // TABLES
  const [openIncidents, setOpenIncidents] = useState<any[]>([]);
  const [criticalIncidents, setCriticalIncidents] = useState<any[]>([]);
  const [closedOnceIncidents, setClosedOnceIncidents] = useState<any[]>([]);
  const [taskTypeData, setTaskTypeData] = useState<any[]>([]);
  const [tasksNextTwoWeeks, setTasksNextTwoWeeks] = useState<any[]>([]);
  const [taskTable, setTaskTable] = useState<any[]>([]);
  const [changeTable, setChangeTable] = useState<any[]>([]);
  const [changeNextTwoWeeks, setChangeNextTwoWeeks] = useState<any[]>([]);
  const [problemData, setProblemData] = useState<any[]>([]);

  const [repetitive, setRetitive] = useState<any[]>([]);

  const modules = [
    { label: "Incident", value: "incident" },
    { label: "Change", value: "change" },
    { label: "Problem", value: "problem" },
    { label: "Task", value: "task" },
  ];
  const [loading, setLoading] = useState(false);
  const formatDate = (date: string) => (date ? `${date}T00:00:00` : null);

  const handleGenerate = async () => {
    setLoading(true);
const plusOneDay = (date: string): string => {
  const d = new Date(date);
  d.setDate(d.getDate() + 1);
  return d.toISOString().split('T')[0]; // or your backend format
};
const minusOneDay = (date: string): string => {
  const d = new Date(date);
  d.setDate(d.getDate() - 1);
  return d.toISOString().split('T')[0]; // or your backend format
};
    const payload = {
      from: formatDate(plusOneDay(periodFrom)),
      to: formatDate((periodTo)),
      customers,
    };



const payload1 = {
  start: formatDate(plusOneDay(periodFrom)),
  end: formatDate((periodTo)),
};

    try {
      // ================= INCIDENT =================
      if (module === "incident") {
        const fullRes = await authFetch(
          `${config.apiBaseUrl}/api/incidents/full`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        const full = await fullRes.json();
        console.log("jacksonnnnnnnnnnnnnn", full);
        setComplaints(full.complaints || []);
        setStatus(full.status || []);
        setCategories(full.categories || []);
        setErrorTypes(full.errorTypes || []);
        setRetitive(full.repetitive || []);

        const chartRes = await authFetch(
          `${config.apiBaseUrl}/api/incidents/incident-chart`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        const chart = await chartRes.json();
        console.log("charttttttttt", chart);
        setNetworkData(
          chart.map((item: any) => ({
            name: item.network,
            links: item.link_count,
            incidents: item.incident_count,
          })),
        );

        const openRes = await authFetch(
          `${config.apiBaseUrl}/api/incidents/open-incidents`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        setOpenIncidents(await openRes.json());

        const tableRes = await authFetch(
          `${config.apiBaseUrl}/api/incidents/report-tables`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        const tables = await tableRes.json();

        setCriticalIncidents(tables.criticalIncidents || []);
        setClosedOnceIncidents(tables.closedNonCriticalIncidents || []);
      }

      // ================= TASK =================
      if (module === "task") {
        const formatDate = (date: string) => (date ? `${date}T00:00:00` : null);

        const url = new URL(`${config.apiBaseUrl}/api/tasks/chart/type`);

        url.searchParams.append("customer", customers[0]);
        url.searchParams.append("fromDate", formatDate(periodFrom)!);
        url.searchParams.append("toDate", formatDate(periodTo)!);

        const typeRes = await authFetch(url.toString(), {
          method: "GET",
        });

        const typeData = await typeRes.json();

        setTaskTypeData(
          typeData.map((item: any) => ({
            name: item[0],
            tasks: item[1],
          })),
        );

        const tableRes = await authFetch(
          `${config.apiBaseUrl}/api/tasks/table`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        setTaskTable(await tableRes.json());

        const nextRes = await authFetch(
          `${config.apiBaseUrl}/api/tasks/table/next-two-weeks?customers=${customers}`,
          {
            method: "POST",
          },
        );

        setTasksNextTwoWeeks(await nextRes.json());
      }

      if (module === "change") {
        const formatDate = (date: string) => (date ? `${date}T00:00:00` : null);

        const tableRes = await authFetch(
          `${config.apiBaseUrl}/api/changes/table`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        setChangeTable(await tableRes.json());

        const nextRes = await authFetch(
          `${config.apiBaseUrl}/api/changes/table/next-two-weeks?customers=${customers}`,
          {
            method: "POST",
          },
        );

        setChangeNextTwoWeeks(await nextRes.json());
      }

      if (module === "problem") {
        const formatDate = (date: string) => (date ? `${date}T00:00:00` : null);

        const url = `${config.apiBaseUrl}/api/problems/table/next-two-weeks?start=${periodFrom}T00:00:00&end=${periodTo}T23:59:59&customers=${customers}`;

        const nextRes = await authFetch(url, {
          method: "POST",
        });

        setProblemData(await nextRes.json());
      }
    } catch (err) {
      console.error("Error fetching report", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ReportingView
      periodFrom={periodFrom}
      periodTo={periodTo}
      setPeriodFrom={setPeriodFrom}
      setPeriodTo={setPeriodTo}
      module={module}
      setModule={setModule}
      customers={customers}
      setCustomers={setCustomers}
      modules={modules}
      handleGenerate={handleGenerate}
      complaints={complaints}
      categories={categories}
      errorTypes={errorTypes}
      status={status}
      networkData={networkData}
      openIncidents={openIncidents}
      criticalIncidents={criticalIncidents}
      closedOnceIncidents={closedOnceIncidents}
      taskTypeData={taskTypeData}
      taskTable={taskTable}
      changeTable={changeTable}
      tasksNextTwoWeeks={tasksNextTwoWeeks}
      loading={loading}
      changeNextTwoWeeks={changeNextTwoWeeks}
      problemData={problemData}
      repetitive={repetitive}
    />
  );
};

export default Reporting;
